module.exports = __webpack_public_path__ + "static/media/pencil-solid.c0772aed.svg";